import { render, staticRenderFns } from "./Vinyle.vue?vue&type=template&id=a51f32b4&scoped=true&"
import script from "./Vinyle.vue?vue&type=script&lang=ts&"
export * from "./Vinyle.vue?vue&type=script&lang=ts&"
import style0 from "./Vinyle.vue?vue&type=style&index=0&id=a51f32b4&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51f32b4",
  null
  
)

export default component.exports